/** Teen Driving Safety client (§22.20) — settings, trips (aggregates), report. */
import { api } from './client';

export interface DrivingSettings {
  child_id: string;
  enabled: boolean;
  speed_limit_kmh: number;
  dnd_recommended: boolean;
}

export interface DrivingIncident {
  kind: string; // 'speed' | 'accel' | 'brake' | 'corner'
  lat: number;
  lng: number;
  speed_kmh: number;
  at: string;
}

export interface DrivingTrip {
  id: string;
  child_id: string;
  started_at: string;
  ended_at: string;
  distance_m: number;
  duration_s: number;
  max_speed_kmh: number;
  avg_speed_kmh: number;
  speed_alert_count: number;
  harsh_event_count: number;
  safety_score: number;
  arrived: boolean;
  incidents: DrivingIncident[];
}

export interface DrivingReport {
  child_id: string;
  period_days: number;
  trips: number;
  total_distance_km: number;
  total_speed_alerts: number;
  total_harsh_events: number;
  avg_safety_score: number;
}

export const drivingApi = {
  settings: (childId: string) =>
    api<DrivingSettings>(`/v1/locations/family/driving/settings/${childId}`),
  updateSettings: (childId: string, input: Partial<Omit<DrivingSettings, 'child_id'>>) =>
    api<DrivingSettings>(`/v1/locations/family/driving/settings/${childId}`, {
      method: 'PUT',
      body: input,
    }),
  trips: (childId: string, limit = 30) =>
    api<DrivingTrip[]>(`/v1/locations/family/driving/trips?child_id=${childId}&limit=${limit}`),
  report: (childId: string, days = 7) =>
    api<DrivingReport>(`/v1/locations/family/driving/report?child_id=${childId}&days=${days}`),
};
